<h2>Admin-Dashboard</h2>

<div class="row">
  <div class="col-sm-6">
    <kendo-card [width]="'auto'">
      <div class="k-vbox">
        <kendo-card-header>
          <h5 kendoCardTitle>
            {{'admin.dashboard.functions.title' | i18n}}
          </h5>
        </kendo-card-header>
        <hr kendoCardSeparator [orientation]="'vertical'" />
        <kendo-card-body>
          <circ-loader [isLoading]="isWorking | async">
            <ul>
              <li>
                <h5>Logging</h5>
                <label [for]="enableDebugSwitch">{{'admin.dashboard.functions.enableDebugLogging.label' | i18n }}</label>
                <kendo-switch #enableDebugSwitch [(ngModel)]="enableDebugLogging"></kendo-switch>
              </li>
              <li>
                <div class="report-form">
                  <kendo-formfield showHint="initial" showErrors="initial" [formGroup]="formGroup" >
                    <h5>{{'admin.dashboard.functions.createReport.header' | i18n }}</h5>
                    <div class="row">
                      <div class="column">
                        <kendo-label [for]="circulationId" [text]="'admin.dashboard.functions.createReport.circulationId'| i18n"></kendo-label>
                        <input kendoTextBox [formControlName]="'circulationId'" type="number" #circulationId required />
                      </div>
                      <div class="column">
                        <kendo-label [for]="overrideExisting" [text]="'admin.dashboard.functions.createReport.overrideExisting'| i18n"></kendo-label>
                        <input type="checkbox" #overrideExisting kendoCheckBox [formControlName]="'overrideExisting'" [checked]="formGroup.controls.overrideExisting.value" />
                      </div>
                      <div class="column">
                        <ece-btn-start (click)="createReport()" [title]="'admin.dashboard.functions.createReport.createButton' | i18n" [text]="'admin.dashboard.functions.createReport.createButton' | i18n"></ece-btn-start>
                      </div>
                    </div>
                    <kendo-formerror>
                      <div *ngIf="formGroup.controls.circulationId.errors?.required">{{ 'circ_new_formerror_title' | i18n }}</div>
                    </kendo-formerror>
                  </kendo-formfield>
                </div>
              </li>
            </ul>
          </circ-loader>
        </kendo-card-body>
      </div>
    </kendo-card>
  </div>
</div>

<div class="row">
  <h1>Beispieldaten</h1>
</div>

<div class="row">
  <div class="col-sm-6">
    <kendo-card [width]="'auto'">
      <div class="k-vbox">
        <kendo-card-header>
          <h5 kendoCardTitle>
            {{ "admin_dashboard_chart_circulations_title" | i18n }}
          </h5>
          <h6 kendoCardSubtitle>
            {{ "admin_dashboard_chart_circulations_subTitle" | i18n }}{{ totalCount$ | async }}
          </h6>
        </kendo-card-header>
        <hr kendoCardSeparator [orientation]="'vertical'" />
        <kendo-card-body>
          <circ-loader [isLoading]="isLoading$ | async">
            <kendo-chart [style.height.px]="200">
              <kendo-chart-series>
                <kendo-chart-series-item
                  [autoFit]="true"
                  type="donut"
                  [data]="circulationsData$ | async"
                  categoryField="status"
                  field="share"
                >
                <!-- NTH Color from css-->
                  <kendo-chart-series-item-labels
                    position="outsideEnd"
                    color="#000"
                    [content]="labelContent"
                  >
                  </kendo-chart-series-item-labels>
                </kendo-chart-series-item>
              </kendo-chart-series>
              <kendo-chart-legend [visible]="true"></kendo-chart-legend>
            </kendo-chart>
          </circ-loader>
        </kendo-card-body>
      </div>
    </kendo-card>

  </div>

</div>
